import ApiService from '@/services/api.service'

const ePharmacyItemsLocationService = {

    getAll(parameter){       
        const requestData = {
            method: 'get',
            url: "/PharmacyLocations/",       
            params: {
              SearchCriteria: parameter.SearchCriteria,
              PageSize: parameter.PageSize,
              PageNumber: parameter.PageNumber,  
              BuildingRestriction: parameter.BuildingRestriction,
              PharmacyRestriction: parameter.PharmacyRestriction,
              FilterByEmployee: parameter.FilterByEmployee
            }
          }
          return ApiService.customRequest(requestData);
    },
    Add(data){
        return ApiService.post(`/PharmacyLocations`, data);
    },
    Delete(Id){      
        return ApiService.delete(`/PharmacyLocations/${Id}`);
    },
    Update(Id,data){
        return ApiService.put(`/PharmacyLocations/${Id}`,data);
    },   
    Get(Id){     
        return ApiService.get(`/PharmacyLocations/${Id}`);
    },
    getAllForRelocation(){    
        const requestData = {
            method: 'get',
            url: "/PharmacyLocations/Relocation",       
        }
        return ApiService.customRequest(requestData);   
    },
    getAllForRemoval(){    
        const requestData = {
            method: 'get',
            url: "/PharmacyLocations/Removal",       
        }
        return ApiService.customRequest(requestData);   
    },    
    getPharmaciesLookup(parameter){
        const requestData = {
            method: 'get',
            url: "/PharmacyLocations/LookUp",
            headers: {
            },
            params: parameter
        }     
        return ApiService.customRequest(requestData);       
    },
}

export default ePharmacyItemsLocationService;